

<form #regForm="ngForm">
	<ng-container *ngFor="let field of fields">
		<ng-container [ngSwitch]="field.fieldName">
			<!--START FIRST NAME-->
			<div *ngSwitchCase="'FirstName'">
				<mat-form-field color="accent" appearance="fill" class="w-100">
					<mat-label>{{'_LOYALTY_REG.first_name' | translate}}</mat-label>
					<input [(ngModel)]="source.firstName" name="firstName" #txtFirstName="ngModel" matInput [required]="required" [matKeyboard]="$storage.customerKeyboard" (enterClick)="focusNext(reglastname)" autocomplete="reg-user-first-name" maxlength="50">
					<mat-icon matSuffix (click)="source.firstName = null" *ngIf="source.firstName">close</mat-icon>
					<mat-error *ngIf="txtFirstName.invalid && (txtFirstName.dirty || txtFirstName.touched)">{{'invalid-requiered' | translate}}</mat-error>
				</mat-form-field>
			</div>
			<!--START LAST NAME-->
			<div *ngSwitchCase="'LastName'">
				<mat-form-field color="accent" appearance="fill" class="w-100">
					<mat-label>{{'_LOYALTY_REG.last_name' | translate}}</mat-label>
					<input [(ngModel)]="source.lastName" name="lastName" #txtLastName="ngModel" matInput [required]="required" [matKeyboard]="$storage.customerKeyboard" (enterClick)="focusNext(regfirstname)" autocomplete="reg-user-last-name" maxlength="50">
					<mat-icon matSuffix (click)="source.lastName = null" *ngIf="source.lastName">close</mat-icon>
					<mat-error *ngIf="txtLastName.invalid && (txtLastName.dirty || txtLastName.touched)">{{'invalid-requiered' | translate}}</mat-error>
				</mat-form-field>
			</div>
			<!--START Email-->
			<div *ngSwitchCase="'Email'">
				<mat-form-field color="accent" appearance="fill" class="w-100">
					<mat-label>{{'_LOYALTY_REG.email' | translate}}</mat-label>
					<input [(ngModel)]="source.email" type="text" email name="email" #txtEmail="ngModel" matInput [required]="required" [matKeyboard]="'email'" (enterClick)="focusNext(reglastname)" autocomplete="new-password" maxlength="50" class="ltr-field">
					<mat-icon matSuffix (click)="source.email = null" *ngIf="source.email">close</mat-icon>
					<mat-error *ngIf="txtEmail.invalid && (txtEmail.dirty || txtEmail.touched)">{{'invalid-requiered' | translate}}</mat-error>
				</mat-form-field>
			</div>
			<!--START Zehut-->
			<div *ngSwitchCase="'Zehut'">
				<mat-form-field color="accent" appearance="fill" class="w-100">
					<mat-label>{{'_LOYALTY_REG.zehut' | translate}}</mat-label>
					<input [(ngModel)]="source.zehut" type="tel" name="zehut" #txtZehut="ngModel" validIdCard matInput [required]="required" [matKeyboard]="'phone'" (enterClick)="focusNext(reglastname)" autocomplete="new-password">
					<mat-icon matSuffix (click)="source.zehut = null" *ngIf="source.zehut">close</mat-icon>
					<mat-error *ngIf="txtZehut.invalid && (txtZehut.dirty || txtZehut.touched)">{{'invalid-requiered' | translate}}</mat-error>
				</mat-form-field>
			</div>
			<!--START BirthDate-->
			<div *ngSwitchCase="'BirthDate'" (mousedown)="birthDatePicker.open()">
				<mat-form-field appearance="fill" class="w-100" style="pointer-events:none">
					<mat-label>{{'_LOYALTY_REG.birthDate' | translate}}</mat-label>
					<input [(ngModel)]="source.birthDate" name="birthDate" matInput [required]="required" [matDatepicker]="birthDatePicker" [max]="loyaltyService.maxBirthdayDate" [min]="loyaltyService.minBirthdayDate" [formControl]="birthDate">
					<mat-datepicker-toggle matSuffix [for]="birthDatePicker"></mat-datepicker-toggle>
					<mat-datepicker #birthDatePicker touchUi [startView]="'multi-year'"></mat-datepicker>
				</mat-form-field>
			</div>
			<!--START Anniversary-->
			<div *ngSwitchCase="'Anniversary'" (mousedown)="anniversaryPicker.open()">
				<mat-form-field appearance="fill" class="w-100" style="pointer-events:none">
					<mat-label>{{'_LOYALTY_REG.anniversary' | translate}}</mat-label>
					<input [(ngModel)]="source.anniversary" name="anniversary" matInput [required]="required" [matDatepicker]="anniversaryPicker" [max]="loyaltyService.maxAnniversary" [min]="loyaltyService.minAnniversary" [formControl]="anniversary">
					<mat-datepicker-toggle matSuffix [for]="anniversaryPicker"></mat-datepicker-toggle>
					<mat-datepicker #anniversaryPicker touchUi [startView]="'multi-year'"></mat-datepicker>
				</mat-form-field>
			</div>
		</ng-container>
	</ng-container>

</form>
